// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","lg":"only screen and (min-width: 75em)","myCoursesContainer":"myCoursesContainer-3SJ5D","myCoursesTitle":"myCoursesTitle-6DWsw","searchContainer":"searchContainer-2XrSr","activitySelect":"activitySelect-wPtFx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/routes/myRoutes/_myCoursesPage.css
// module id = 1261
// module chunks = 1